import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import Chatbot from '@components/Chatbot';
import ValuationDashboard from '@pages/ValuationDashboard';
import LandingPage from '@pages/LandingPage';
import MainLayout from '@components/layout/MainLayout';

const miscRoutes = [
  <Route key="landing" path="/" element={<LandingPage />} />,
  <Route
    key="chat"
    path="/chat"
    element={
      <div style={{ height: '100vh' }}>
        <Chatbot />
      </div>
    }
  />,
  <Route
    key="dashboard"
    path="/dashboard"
    element={
      <MainLayout>
        <ValuationDashboard />
      </MainLayout>
    }
  />,
  <Route
    key="market-research"
    path="/market-research"
    element={
      <MainLayout>
        <div>Market Research (Coming Soon)</div>
      </MainLayout>
    }
  />,
  <Route
    key="financial-analysis"
    path="/financial-analysis"
    element={
      <MainLayout>
        <div>Financial Analysis (Coming Soon)</div>
      </MainLayout>
    }
  />,
  <Route
    key="trends"
    path="/trends"
    element={
      <MainLayout>
        <div>Market Trends (Coming Soon)</div>
      </MainLayout>
    }
  />,
  <Route
    key="valuations"
    path="/valuations"
    element={
      <MainLayout>
        <div>Valuations (Coming Soon)</div>
      </MainLayout>
    }
  />,
  <Route
    key="reports"
    path="/reports"
    element={
      <MainLayout>
        <div>Reports (Coming Soon)</div>
      </MainLayout>
    }
  />,
  <Route
    key="settings"
    path="/settings"
    element={
      <MainLayout>
        <div>Settings (Coming Soon)</div>
      </MainLayout>
    }
  />,
  <Route
    key="profile"
    path="/profile"
    element={
      <MainLayout>
        <div>User Profile (Coming Soon)</div>
      </MainLayout>
    }
  />,
  <Route key="catch-all" path="*" element={<Navigate to="/" replace />} />
];

export default miscRoutes;